<template>
  <div
    class="powerDensityWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="selectWrap commonWrap">
      <LightingMenu @getSelectData="getSelectData" />
    </div>
    <div class="bottomWrap">
      <div class="leftMenuBox">
        <ul>
          <li v-for="(v, i) in summary" :key="i">
            <p>{{ v.name }}</p>
            <h4>
              {{ v.value }} <span>{{ v.unit }}</span>
            </h4>
          </li>
        </ul>
      </div>
      <div class="rightMenuBox">
        <div class="chartWrap">
          <div class="containerBox commonWrap">
            <PowerDensityLine :lineData="lineData" />
          </div>
          <div class="containerBox commonWrap">
            <PowerDensityBar :chartsData="barData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PowerDensityLine from "@/components/zixitong/lightingSystem/PowerDensityLine";
import PowerDensityBar from "@/components/zixitong/lightingSystem/PowerDensityBar";
import LightingMenu from "@/components/zixitong/lightingSystem/LightingMenu";
import api from "@/api";
export default {
  components: {
    PowerDensityLine,
    PowerDensityBar,
    LightingMenu,
  },
  data() {
    return {
      summary: [],
      lineData: {},
      barData: {},
    };
  },
  methods: {
    async getSelectData(data) {
      this.$store.commit("SET_LOADING", true);
      let res = await api.subsystemPowerRanking({
        beginTime: data.timeData[0],
        endTime: data.timeData[1],
        id: data.defaultId,
      });
      // console.log(res);
      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.lineData = {
          xData: [],
          averageData: [],
          myData: [],
        };
        this.barData = {
          yData: [],
          data: [],
        };
        this.summary = res.data.summary;
        res.data.target.average.forEach((v, i) => {
          this.lineData.xData.push(v.time);
          this.lineData.averageData.push(v.value);
          this.lineData.myData.push(res.data.target.my[i].value);
        });
        res.data.ranking.forEach((v) => {
          this.barData.yData.push(v.name);
          this.barData.data.push(v.value);
        });
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.powerDensityWrap {
  @include setFlexColumn;
  justify-content: space-around;
  .selectWrap {
    width: 96%;
    height: 80px;
    margin: 10px auto 0;
    @include setFlexBetween;
    justify-content: flex-start;
  }
  .bottomWrap {
    width: 96%;
    height: calc(100% - 135px);
    margin: 10px auto;
    @include setFlexBetween;
    .leftMenuBox {
      width: 25%;
      height: 100%;
      ul {
        width: 100%;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0px 0px 26px 0px rgba(51, 51, 51, 0.1);
        li {
          padding: 20px 30px 0 30px;
          font-size: 16px;
          @include setFlexStart;
          color: #333;
          h4 {
            margin: 0 5px 0 30px;
            color: #f8181f;
            font-size: 24px;
            span {
              color: #999;
              font-size: 16px;
            }
          }
        }
        li:last-child {
          padding-bottom: 30px;
        }
      }
    }
    .rightMenuBox {
      width: 73%;
      height: 100%;
      .chartWrap {
        width: 100%;
        height: 100%;
        @include setFlexColumn;
        justify-content: space-between;
        .containerBox {
          height: 49%;
          box-shadow: 0px 0px 26px 0px rgba(51, 51, 51, 0.1);
        }
      }
    }
  }
}
</style>